































import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {DebtEmployee} from "@/interfaces/entity";
import {ReceiptPartnerStore} from "@/modules/receiptsexpenses/receiptpartner/store";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import LadingPaymentTypeLabel from "@/modules/ladings/List/components/PaymentTypeLabel.vue";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";

const columns = [
    {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        width: 80
    },
    {
        title: "Ngày phát hành",
        dataIndex: "billLading.ladingDate",
        key: "ladingDate",
        width: 150,
        ellipsis: true,
        scopedSlots: {customRender: 'ladingDate'}
    },
    {
        title: "Mã vận đơn",
        dataIndex: "billLading.ladingCode",
        key: "ladingCode",
        width: 150,
        ellipsis: true
    },
    {
        title: "Thu tiền NN",
        dataIndex: "billLading.receiverCollect",
        key: "receiverCollect",
        scopedSlots: {customRender: 'receiverCollect'},
        width: 150,
        ellipsis: true
    },
    {
        title: "Tổng thu",
        dataIndex: "money",
        key: "money",
        scopedSlots: {customRender: 'money'},
        width: 120,
        ellipsis: true
    },
    {
        title: "Trạng thái bưu gửi",
        dataIndex: "billLading.status",
        key: "statusLading",
        scopedSlots: {customRender: 'statusLading'},
        width: 180,
        ellipsis: true
    },
    {
        title: "Đối tác",
        dataIndex: "partner.name",
        key: "partner",
        width: 150,
        ellipsis: true
    }
];
@Component({
    name: "ReceiptPartnerTable",
    components: {LadingPaymentTypeLabel, LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop() readonly debtPartners!: Array<DebtEmployee>;
    columns = columns;

    get pagination() {
        return {
            current: ReceiptPartnerStore.meta.page,
            pageSize: ReceiptPartnerStore.meta.limit,
            total: ReceiptPartnerStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} bản ghi`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        ReceiptPartnerStore.updateParamsDebtPartner({
            ...ReceiptPartnerStore.params,
            page: pagination.current,
            limit: pagination.pageSize
        })
        ReceiptPartnerStore.listDebtPartner(ReceiptPartnerStore.params);
    }
}
